import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c6e8ec9c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e8ec9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6e8ec9c')) {
      api.createRecord('c6e8ec9c', component.options)
    } else {
      api.reload('c6e8ec9c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c6e8ec9c&scoped=true", function () {
      api.rerender('c6e8ec9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/agreement/index.vue"
export default component.exports